/* esm.sh - @emotion/memoize@0.9.0 */
export * from "/*@emotion/memoize@0.9.0/esnext/memoize.mjs";
export { default } from "/*@emotion/memoize@0.9.0/esnext/memoize.mjs";
